module.exports = __webpack_public_path__ + "img/124ne.5a55ef1d.svg";